import { useQuery, UseQueryResult } from 'react-query';
import { getAllRouteIds, getAllRoutes, getRoutesByIds } from '../sp-firebase/routesFB';
import { getAllRouteDetailsIds, getRoutesDetailsByIds } from '../sp-firebase/routeDetailsFB';
import { IRoute } from '../sp-types';
import { makeMap } from '../utils/routesUtils';

export const useRouteById = (routeId: string[] | undefined) => {
  const enable = routeId !== undefined;
  const fetchFunction = () => getRoutesByIds(routeId || []);
  return useQuery('selected-routes', fetchFunction, { enabled: enable });
};

export const useRouteDetailById = (routeId: string) => {
  const fetchFunction = () => getRoutesDetailsByIds([routeId]);
  return useQuery('route-details', fetchFunction);
};

export const useGetAllRouteIds = () => {
  const fetchFunction = () => getAllRouteIds();
  return useQuery('route-ids', fetchFunction);
};

export const useGetAllRouteDetailsIds = () => {
  const fetchFunction = () => getAllRouteDetailsIds();
  return useQuery('route-details-ids', fetchFunction);
};

export const useAllRoutes = (): UseQueryResult<Record<string, IRoute>, unknown> => {
  const fetchFunction = async (): Promise<Record<string, IRoute>> => {
    const routes = await getAllRoutes();
    return makeMap(routes || [], 'id');
  };

  return useQuery<Record<string, IRoute>>('all-routes', fetchFunction);
};
